import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold text-gradient hidden sm:block" }, "TubeMate", -1)

import { Icon } from "@iconify/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: "/",
    class: "logo flex gap-4 items-center z-20 h-[70px]"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Icon), {
        icon: "bi:youtube",
        class: "text-5xl text-primary_1"
      }),
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})